import React from 'react';
import {observable, action, makeObservable} from 'mobx';
import {observer} from 'mobx-react';
import store from '../../../s';
import * as util from '../../../../util';
import Confidence from '../../confidence';
import ModalPromo from '../../modals/promo';
import CartItemsMobile from './cart-items-mobile';

declare const collapse: {
    init: () => void;
};

@observer
class CartMobile extends React.Component {
    @observable randInt: number;
    @observable editingPromo: boolean;

    constructor(props) {
        super(props);
        this.randInt = Math.floor(Math.random() * 1000000001);
        this.handleCheckoutTypeChange = this.handleCheckoutTypeChange.bind(this);
        this.resetCart = this.resetCart.bind(this);
        this.reloadPayment = this.reloadPayment.bind(this);
        this.reloadPaymentFailure = this.reloadPaymentFailure.bind(this);
        this.refreshStuff = this.refreshStuff.bind(this);
        this.editingPromo = false;
        makeObservable(this);
    }

    componentDidMount(): void {
        collapse.init();
        store.checkoutRefreshCS = this.refreshStuff;
    }

    @action
    resetCart = async () => {
        store.initCheckout();
        store.uiCheckout.requireReset = true;
        store.moveStep(ICheckoutStep.cart);
        this.forceUpdate();
    };

    @action
    handleCheckoutTypeChange = async (e: ICheckoutType) => {
        if (store.checkout.force_normal_checkout) {
            store.checkout.CheckoutType = ICheckoutType.normal;
            store.moveStep(ICheckoutStep.checkout);
            return;
        }

        store.checkout.CheckoutType = e;
        store.checkout.force_normal_checkout = true;
        store.moveStep(ICheckoutStep.checkout);
    };

    @action
    reloadPayment = async () => {
        this.editingPromo = false;
        try {
            store.checkoutReloadPayment();
        } catch (err) {
            const x = 1;
        }
        this.forceUpdate();
    };

    @action
    reloadPaymentFailure = async () => {
        this.editingPromo = true;
        try {
            store.checkoutReloadPayment();
        } catch (err) {
            const x = 1;
        }
        this.forceUpdate();
    };

    @action
    refreshStuff = async () => {
        this.forceUpdate();
    };

    render() {
        collapse.init();

        return (
            <div
                className="cs cs-mobile"
                style={{
                    border: 'none',
                    height: '100%',
                    display: 'flex',
                    position: 'relative',
                    flexDirection: 'column',
                    justifyContent: store.checkout.cart.items?.length ? 'space-between' : '',
                }}
            >
                {!!store.checkout.cart.items?.length && (
                    <div
                        style={{
                            overflowY: 'scroll',
                            height: 'calc(100vh - 195px)',
                        }}
                    >
                        <CartItemsMobile id={100} />
                        <Confidence />
                        <div className="hr"></div>
                        <div>
                            <ModalPromo
                                reloadPaymentFailure={this.reloadPaymentFailure}
                                reloadPayment={this.reloadPayment}
                                modalId="modal-checkout-promo-cs"
                            />
                        </div>
                    </div>
                )}
                {store.checkout.cart.items && store.checkout.cart.items.length > 0 && (
                    <div
                        id={`cartSummaryCollapse${this.randInt.toString()}`}
                        style={{
                            position: 'absolute',
                            bottom: 0,
                            height: 195,
                            width: '100%',
                            background: 'white',
                        }}
                    >
                        <div className="cs-flex">
                            <span>Subtotal</span>
                            <div
                                aria-label="Subtotal"
                                style={{padding: 0}}
                            >
                                {util.currency(store.checkout.cart.pricing.subtotal)}
                            </div>
                        </div>

                        {store.checkout.cstep <= ICheckoutStep.cart && (
                            <div
                                className="cs-btn"
                                style={{marginLeft: 0, marginRight: 0}}
                            >
                                <div style={{paddingTop: 0}}>
                                    <button
                                        type="button"
                                        className="btn-checkout btn-checkout-blue"
                                        onClick={() => this.handleCheckoutTypeChange(ICheckoutType.normal)}
                                        style={{marginTop: 6, borderRadius: 10}}
                                        aria-label="Checkout"
                                    >
                                        <span className="pad-right">
                                            <i className="fas fa-lock"></i>
                                        </span>
                                        Secure Checkout
                                    </button>
                                </div>

                                <button
                                    type="button"
                                    className={`btn-checkout btn-checkout-yellow${store.PortalID === 3 ? ' btn-checkout-yellow-portal3' : ''}`}
                                    style={{
                                        textTransform: 'uppercase',
                                        marginTop: 10,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        padding: 0,
                                        borderRadius: 10,
                                        border: 'none',
                                    }}
                                    onClick={() => window.open('https://www.paypal.com/us/digital-wallet/ways-to-pay/buy-now-pay-later')}
                                >
                                    Pay in installments with
                                    <picture style={{marginLeft: 10, marginTop: -5}}>
                                        <source
                                            srcSet={`https://${store.Portal.CDNDomain}/images/cached/general/pp_logo_h_100x26.webp`}
                                            type="image/webp"
                                        />
                                        <img
                                            src={`https://${store.Portal.CDNDomain}/images/cached/general/pp_logo_h_100x26.png`}
                                            width={70}
                                            height="auto"
                                            alt="Pay in installments with"
                                        />
                                    </picture>
                                </button>
                            </div>
                        )}
                    </div>
                )}

                {(!store.checkout.cart.items || store.checkout.cart.items.length < 1) && (
                    <div
                        className="text-center"
                        style={{paddingTop: 24, paddingBottom: 24}}
                    >
                        <div
                            className="form-inline-label"
                            style={{fontSize: 28}}
                        >
                            Your cart is empty.
                        </div>
                        {store.PortalID === 3 && (
                            <div
                                className="link"
                                style={{marginTop: 36}}
                            >
                                <a
                                    href="/"
                                    title="Diploma Frames"
                                >
                                    Visit our Framerly Shop
                                </a>
                            </div>
                        )}
                        {store.PortalID === 0 && (
                            <div
                                className="link"
                                style={{marginTop: 36}}
                            >
                                <a
                                    href="/shop-frames-gifts.aspx"
                                    title="Diploma Frames"
                                    aria-label="Visit our Shop Frames and Gifts page"
                                >
                                    Visit our Shop Frames and Gifts page
                                </a>
                            </div>
                        )}
                        {store.PortalID === 0 && (
                            <div
                                className="link"
                                style={{marginTop: 36}}
                            >
                                <a
                                    href="/frame-designer"
                                    title="Custom Frame"
                                    aria-label="Custom Frame"
                                >
                                    Create your own Custom Frame
                                </a>
                            </div>
                        )}
                        {store.PortalID === 0 && (
                            <div
                                className="link"
                                style={{marginTop: 36}}
                            >
                                <a
                                    href="/about-our-frames/frames-custom-made-for-you.aspx"
                                    title="About Our Frames"
                                    aria-label="About Our Frames"
                                >
                                    Learn more about our frames
                                </a>
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

export default CartMobile;
